
import { MathUtils } from "three";
import { sceneUnitsFromMm } from "./scaler";

export const tolerances = {
    direction: sceneUnitsFromMm(0.01), // When comparing values of direction vectors together
    position: sceneUnitsFromMm(0.1), // When comparing values of position vectors together
    directionAngle: MathUtils.degToRad(1), // When comparing angle between direction vectors

    // How close to degenerate the view angle must get before an edit handle is dropped.
    // Separate values because the two degeneracies read differently to the eye: depth changes
    // become hard to judge well before the view is exactly along the drag axis, while a plane
    // stays workable until it is nearly edge-on.
    editHandleViewAlongAxis: MathUtils.degToRad(20), // view within this of a handle's drag axis
    editHandlePlaneEdgeOn: MathUtils.degToRad(10), // view within this of lying in a handle's plane
};